import Spinner from 'app/components/Spinner';
import { setUserInfo } from 'app/utils';
import { refreshToken } from 'app/utils/refreshToken';
import { getSubscriptionIdFromPath } from 'app/utils/routing';
import { setSessionLogger } from 'app/utils/sessionLogger';
import { Suspense, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import PrivateLayoutBackdrop from '../PrivateLayoutBackdrop';

const PrivateLayout = () => {
  const accessToken = useSelector(({ user }) => user.accessToken);
  const { featureFlagsLoading, loadedSubscriptionId } = useSelector(
    ({ common }) => common
  );
  const { pathname } = useLocation();
  const subscriptionId = getSubscriptionIdFromPath(pathname);
  const [tokenChecked, setTokenChecked] = useState(!!accessToken);

  useEffect(() => {
    if (!accessToken) {
      refreshToken()
        .then(() => {
          setUserInfo();
          setSessionLogger();
          setTokenChecked(true);
        })
        .catch(() => {
          setTokenChecked(true);
        });
    }
  }, []);

  const isLoading = useMemo(() => {
    return (
      featureFlagsLoading ||
      (!!subscriptionId && loadedSubscriptionId !== subscriptionId)
    );
  }, [featureFlagsLoading, subscriptionId, loadedSubscriptionId]);

  if (!tokenChecked) {
    return <Spinner />;
  }
  if (!accessToken) {
    return <Navigate to='/login' replace />;
  }

  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <Suspense fallback={<Spinner />}>
          <Outlet />
        </Suspense>
      )}
      <PrivateLayoutBackdrop />
    </>
  );
};

export default PrivateLayout;
